import React, { Component } from 'react';
import Waypoint from 'react-waypoint';

class AnimationPoint extends Component {
  render() {
    const { enter, leave, bottomOffset, topOffset } = this.props;
    return (
      <Waypoint onEnter={enter} onLeave={leave} bottomOffset={bottomOffset} topOffset={topOffset || "100px"} />
    );
  }
}

export default AnimationPoint;



// WEBPACK FOOTER //
// ./src/components/AnimationPoint.jsx